import mixpanel from "mixpanel-browser";
import { SWITCH_BRAND } from "./switch_brand_actions";

const null_data = {
  brand_id: "",
  brand_name: "",
};

const selectedBrandReducer = (state = null_data, payload = {}) => {
  const { type, brand_id, brand_name } = payload;
  switch (type) {
    case SWITCH_BRAND:
      mixpanel.register(
        { selected_brand_id: brand_id, selected_brand_name: brand_name },
        { persistent: false }
      );
      return { ...state, brand_id, brand_name };
    default:
      return state;
  }
};

export default selectedBrandReducer;
